import { render, staticRenderFns } from "./ReviewGridComponent.vue?vue&type=template&id=23147d3d&scoped=true&"
import script from "./ReviewGridComponent.vue?vue&type=script&lang=js&"
export * from "./ReviewGridComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReviewGridComponent.vue?vue&type=style&index=0&id=23147d3d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23147d3d",
  null
  
)

export default component.exports